package org.hs_soft.runmynesto.pages.home.sub_page.options.component.tabs.restaurant_manager.components.restaurant_project.objects

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.model.general.ButtonTypes
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.model.home.options.restaurant_manager.ObjectKindTypes
import org.hs_soft.runmynesto.domain.model.home.options.restaurant_manager.ObjectKinds
import org.hs_soft.runmynesto.domain.model.home.options.restaurant_manager.ShapeEnum
import org.hs_soft.runmynesto.domain.model.home.options.restaurant_manager.restaurant_project.Furniture
import org.hs_soft.runmynesto.domain.util.Res
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.pages.components.CustomEditText
import org.hs_soft.runmynesto.pages.components.CustomIcon
import org.hs_soft.runmynesto.pages.components.PaintIcon
import org.hs_soft.runmynesto.pages.components.RestaurantObject
import org.hs_soft.runmynesto.pages.components.Separator
import org.hs_soft.runmynesto.pages.components.VectorIcon
import org.hs_soft.runmynesto.pages.components.dialog.component.CustomButton
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.px

@Composable
fun RestaurantTable(
    windowSizeMode: WindowSizeModeEnum,
    selectedTableColor: String,
    selectedFurniture: Furniture?,
    onRestaurantTableColorClick: () -> Unit,
    onCreateTableClick: (ShapeEnum, String) -> Unit,
    onUpdateTable: (String) -> Unit,
) {
    val number= remember { mutableStateOf("") }
    val furniture= remember { mutableStateOf<Furniture?>(selectedFurniture) }
    val isExpanded= remember { mutableStateOf(true) }

    LaunchedEffect(selectedFurniture){
        furniture.value=selectedFurniture
        number.value=selectedFurniture?.caption?:""
    }


    Column(
        modifier = Modifier
            .borderRadius(Dimen.lowBorderRadius)
            .border(
                width = Dimen.smallThickness,
                style = LineStyle.Solid,
                color = Theme.ActionDisabledBackground.rgb
            )
            .fillMaxWidth()
            .margin(top = Dimen.normalPadding)
    )
    {

        RestaurantProjectObjectHeader(
            isExpanded =isExpanded.value ,
            title=Strings.current().table,
            onItemClick = {
                isExpanded.value=!isExpanded.value
            }
        )



        if (isExpanded.value){

            Column(
                modifier = Modifier
                    .padding(
                        bottom = Dimen.largePadding,
                    )
                    .fillMaxWidth()
            ) {

                Separator(
                    modifier = Modifier
                        .margin(bottom = Dimen.largePadding)
                )

                Column(
                    modifier = Modifier
                        .padding(leftRight = Dimen.largePadding,)
                ){

                    Row()
                    {
                        ObjectKinds.entries
                            .filter {
                                it.type==ObjectKindTypes.TABLE
                            }
                            .forEach {
                                RestaurantObject(
                                    selectedFurniture = furniture.value,
                                    objectInfo = it,
                                    onClick = {
                                        if (selectedFurniture==null){
                                            furniture.value = Furniture(
                                                                objectKind = it.value,
                                                                shape = it.shape?.value,
                                                                width = it.width,
                                                                height = it.height,
                                                              )
                                        }
                                    }
                                )
                            }


                    }


                    Row(
                        modifier = Modifier
                            .margin(
                                top = Dimen.normalPadding,
                                bottom = Dimen.extraLargePadding
                            ),
                        verticalAlignment = Alignment.Bottom
                    )
                    {

                        CustomEditText(
                            modifier = Modifier,
                            width = Dimen.normalEditTextWidth2,
                            marginRight = Dimen.largePadding,
                            marginBottom = 0.px,
                            inputType = InputType.Number,
                            label = Strings.current().tableNumber,
                            value = selectedFurniture?.caption?:"",
                            isRequired = false,
                            hint = Strings.current().enterTableNumber,
                            isOutlinedEditText = true,
                            onFocusIn = {},
                            onFocusOut = {

                            },
                            onInputChange = {it, validation ->
                                number.value=it
                            },
                        )



                        PaintIcon(
                            selectedColor = selectedTableColor,
                            onPaintIconClick = {
                                onRestaurantTableColorClick()
                            }
                        )

                    }




                    CustomButton(
                        modifier = Modifier
                            .margin(topBottom = Dimen.normalPadding),
                        width = Dimen.restaurantInfoAddWidth,
                        title = if (selectedFurniture==null ||
                            selectedFurniture.objectKind!=ObjectKinds.TABLE_RECTANGLE.value)
                            Strings.current().addElement
                        else Strings.current().editElement,
                        isClickable = furniture.value?.objectKind==ObjectKinds.TABLE_RECTANGLE.value
                                || furniture.value?.objectKind==ObjectKinds.TABLE_ROUND.value,
                        buttonType = ButtonTypes.CONTAINED,
                        onButtonClick = {
                            val shapeEnum=ShapeEnum.entries.find {it:ShapeEnum->
                                it.value==furniture.value?.shape
                            }
                            if (selectedFurniture?.objectKind==ObjectKinds.TABLE_RECTANGLE.value
                                || selectedFurniture?.objectKind==ObjectKinds.TABLE_ROUND.value
                            ){
                                onUpdateTable(number.value)
                            }else{
                                onCreateTableClick(shapeEnum!!,number.value)
                            }

                        },
                    )
                }

            }

        }




    }
    
}



